import { render } from "./ShowAlbums.vue?vue&type=template&id=14ff1c36&scoped=true"
import script from "./ShowAlbums.vue?vue&type=script&lang=js"
export * from "./ShowAlbums.vue?vue&type=script&lang=js"

import "./ShowAlbums.vue?vue&type=style&index=0&id=14ff1c36&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ff1c36"]])

export default __exports__